
import React, {Component} from 'react'
import PrintPreview from '../PrintPreview'
import ReportStore from 'stores/ReportStore'
import { momentHelper } from '../../report/helpers'
const DEFAULT_ROW = 15
const DEFAULT_NEW_ROW = 0
class PrintReportStockCardCost extends Component {

  constructor(...args){
    super(...args)

    this.state = {
      data:{dataFormat:[],data:[]},
      report_title:'กำลังดึงข้อมูล..'
    }

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('landscape');
  }

  componentDidMount(){
    this.loadData()
  }

  setItem(result) {
      let check_date = []
      let dataFormat = []
      var id = []
      var itemnum = []
      var bill_type = []
      var added_date = []
      var in_cost = []
      var in_quantity = []
      var in_total = []
      var out_cost = []
      var out_quantity = []
      var out_total = []
      var balance_cost = []
      var balance_quantity = []
      var balance_total = []
      var sum_in_cost = 0
      var sum_in_quantity = 0
      var sum_in_total = 0
      var sum_out_cost = 0
      var sum_out_quantity = 0
      var sum_out_total = 0
      var sum_balance_cost = 0
      var sum_balance_quantity = 0
      var sum_balance_total = 0

      for (var ii=0;ii<result.data.length;ii++) {
        if (check_date.indexOf(result.data[ii].description)===-1) {
          check_date.push(result.data[ii].description)
        }
      }

      for (var i=0;i<check_date.length;i++) {
        // let left_in_cost = 0
        // let left_in_quantity = 0
        // let left_in_total = 0

        // let left_out_cost = 0
        // let left_out_quantity = 0
        // let left_out_total = 0

        for (var j=0;j<result.data.length;j++) {            
          if (check_date[i]===result.data[j].description) {
            if(result.data[j].record_type=='left_balance'){
              // left_in_cost = result.data[j].in_cost;
              // left_in_quantity = result.data[j].in_quantity;
              // left_in_total = result.data[j].in_total;

              // left_out_cost = result.data[j].out_cost;
              // left_out_quantity = result.data[j].out_quantity;
              // left_out_total = result.data[j].out_total;
            }
            id.push(result.data[j].ref_bill_no)
            itemnum.push(result.data[j].itemnum)
            added_date.push(result.data[j].added_date)
            bill_type.push(result.data[j].bill_type)

            in_cost.push(result.data[j].in_cost===undefined?0:result.data[j].in_cost)
            out_cost.push(result.data[j].out_cost===undefined?0:result.data[j].out_cost)
            balance_cost.push(result.data[j].balance_cost)

            in_quantity.push(result.data[j].in_quantity===undefined?0:result.data[j].in_quantity)
            out_quantity.push(result.data[j].out_quantity===undefined?0:result.data[j].out_quantity)
            balance_quantity.push(result.data[j].balance_quantity)

            in_total.push(result.data[j].in_total===undefined?0:result.data[j].in_total)
            out_total.push(result.data[j].out_total===undefined?0:result.data[j].out_total)
            balance_total.push(result.data[j].balance_total)

            sum_in_cost = (sum_in_cost*1) + ((result.data[j].in_cost===undefined?0:result.data[j].in_cost)*1)
            sum_out_cost = (sum_out_cost*1) + ((result.data[j].out_cost===undefined?0:result.data[j].out_cost)*1)
            sum_balance_cost = (sum_balance_cost*1) + ((result.data[j].balance_cost===undefined?0:result.data[j].balance_cost)*1)

            sum_in_quantity = (sum_in_quantity*1) + ((result.data[j].in_quantity===undefined?0:result.data[j].in_quantity)*1)
            sum_out_quantity = (sum_out_quantity*1) + ((result.data[j].out_quantity===undefined?0:result.data[j].out_quantity)*1)
            sum_balance_quantity = (sum_balance_quantity*1) + ((result.data[j].balance_quantity===undefined?0:result.data[j].balance_quantity)*1)

            sum_in_total = (sum_in_total*1) + ((result.data[j].in_total===undefined?0:result.data[j].in_total)*1)
            sum_out_total = (sum_out_total*1) + ((result.data[j].out_total===undefined?0:result.data[j].out_total)*1)
            sum_balance_total = (sum_balance_total*1) + ((result.data[j].balance_total===undefined?0:result.data[j].balance_total)*1)
          }
        }
        
        dataFormat.push({
          description: check_date[i],
          meta: {
            id: id,
            itemnum: itemnum,
            bill_type: bill_type,
            added_date: added_date,
            in_cost: in_cost,
            out_cost: out_cost,
            balance_cost: balance_cost,
            in_quantity: in_quantity,
            out_quantity: out_quantity,
            balance_quantity: balance_quantity,
            in_total: in_total,
            out_total: out_total,
            balance_total: balance_total
          },
          sum_in_cost: sum_in_cost,
          sum_out_cost: sum_out_cost,
          sum_balance_cost:  sum_balance_cost,
          sum_in_quantity: sum_in_quantity,
          sum_out_quantity: sum_out_quantity,
          sum_balance_quantity:  sum_balance_quantity,
          sum_in_total: sum_in_total,
          sum_out_total: sum_out_total,
          sum_balance_total:  sum_balance_total
        })
        id = []
        itemnum = []
        bill_type = []
        added_date = []
        in_cost = []
        out_cost = []
        balance_cost = []
        sum_in_cost = 0
        sum_out_cost = 0
        sum_balance_cost = 0

        in_quantity = []
        out_quantity = []
        balance_quantity = []
        sum_in_quantity = 0
        sum_out_quantity = 0
        sum_balance_quantity = 0

        in_total = []
        out_total = []
        balance_total = []
        sum_in_total = 0
        sum_out_total = 0
        sum_balance_total = 0
      }

      let {data} = this.state
      data.dataFormat = this.getPagination(dataFormat)
      data.data = dataFormat
      this.setState({data:data,report_title:'ไม่พบข้อมูล'})
  }

  loadData() {
    if (this.props.year!=undefined&&this.props.month!=undefined&&this.props.day!=undefined&&this.props.cat_id!=undefined&&this.props.itemnum!=undefined) {
      ReportStore.loadReportStockCardCost(this.props.year,this.props.month,this.props.day,0,'',this.props.cat_id,this.props.itemnum,(result) => {
        this.setItem(result)
      },()=>{

      })   
    } else if (this.props.isRange=='true'&&this.props.startDate!=undefined&&this.props.endDate!=undefined&&this.props.cat_id!=undefined&&this.props.itemnum!=undefined) {
        ReportStore.loadReportStockCardCostRange(this.props.startDate,this.props.endDate,0,'',this.props.cat_id,this.props.itemnum,(result)=>{
          this.setItem(result)
        },()=>{
            
        })
    } else {
        this.setState({data:{dataFormat:[],data:[]},report_title:'ไม่พบข้อมูล'})
    }
  }

  getPagination(data) {
    let allData = []
    let newData = []
    let partData = {}
    let _id = []
    let _added_date = []
    let _bill_type = []
    let _in_quantity = []
    let _out_quantity = []
    let _balance_quantity = []
    let _in_cost = []
    let _out_cost = []
    let _balance_cost = []
    let _in_total = []
    let _out_total = []
    let _balance_total = []
    let checkRow = 0
    
    data.forEach(function(item,index) {
      item.meta.id.forEach(function(items,indexs) {
        if (checkRow<DEFAULT_ROW) {
          _id.push(items)
          _added_date.push(item.meta.added_date[indexs])
          _bill_type.push(item.meta.bill_type[indexs])
          _in_quantity.push(item.meta.in_quantity[indexs])
          _out_quantity.push(item.meta.out_quantity[indexs])
          _balance_quantity.push(item.meta.balance_quantity[indexs])
          _in_cost.push(item.meta.in_cost[indexs])
          _out_cost.push(item.meta.out_cost[indexs])
          _balance_cost.push(item.meta.balance_cost[indexs])
          _in_total.push(item.meta.in_total[indexs])
          _out_total.push(item.meta.out_total[indexs])
          _balance_total.push(item.meta.balance_total[indexs])
          checkRow++
        }
        if (item.meta.id.length-1===indexs||checkRow===DEFAULT_ROW-1) {
          let sum_row = true
          if (item.meta.id.length-1!==indexs&&checkRow===DEFAULT_ROW-1)
            sum_row = false

          newData.push({
            description:item.description,
            sum_in_quantity:0,
            sum_out_quantity:0,
            sum_balance_quantity:0,
            sum_in_cost:0,
            sum_out_cost:0,
            sum_balance_cost:0,
            sum_in_total:0,
            sum_out_total:0,
            sum_balance_total:0
          })

          partData = {
            sum_row:sum_row,
            // description:item.description,
            meta: {
              id:_id,
              added_date:_added_date,
              bill_type:_bill_type,
              in_quantity:_in_quantity,
              out_quantity:_out_quantity,
              balance_quantity:_balance_quantity,
              in_cost:_in_cost,
              out_cost:_out_cost,
              balance_cost:_balance_cost,
              in_total:_in_total,
              out_total:_out_total,
              balance_total:_balance_total,
            },  
            sum_in_quantity:item.sum_in_quantity,
            sum_out_quantity:item.sum_out_quantity,
            sum_balance_quantity:item.sum_balance_quantity,
            sum_in_cost:item.sum_in_cost,
            sum_out_cost:item.sum_out_cost,
            sum_balance_cost:item.sum_balance_cost,
            sum_in_total:item.sum_in_total,
            sum_out_total:item.sum_out_total,
            sum_balance_total:item.sum_balance_total
          }

          newData.push(partData)
          partData = {}
          _id = []
          _added_date = []
          _bill_type = []
          _in_quantity = []
          _out_quantity = []
          _balance_quantity = []
          _in_cost = []
          _out_cost = []
          _balance_cost = []
          _in_total = []
          _out_total = []
          _balance_total = []
        }
      
        if ((checkRow===DEFAULT_ROW-1)||(data.length-1===index&&item.meta.id.length-1===indexs)) {
          allData.push({
            dataList:newData
          })
          newData = []
          checkRow = DEFAULT_NEW_ROW
        }
      })
    })
    return allData
  }

  getNumberFormat(val) {
    if (val!==''&&val!==null&&val!==undefined&&!isNaN(val)) {
      if (val==='0'||val===0)
        return <br />
      else  
        return parseFloat(val).toLocaleString(undefined, {maximumFractionDigits: 2}) 
    }
    return <br />
  }

  renderRowSummary() {
    let {data} = this.state
    let sum_in_quantity = 0
    let sum_out_quantity = 0
    // let sum_balance_quantity = 0
    let sum_in_cost = 0
    let sum_out_cost = 0
    // let sum_balance_cost = 0
    let sum_in_total = 0
    let sum_out_total = 0
    // let sum_balance_total = 0
    data.data.forEach(function(item,index) {
      sum_in_quantity += parseFloat(item.sum_in_quantity)
      sum_out_quantity += parseFloat(item.sum_out_quantity)
      // sum_balance_quantity += parseFloat(item.sum_balance_quantity)
      sum_in_cost += parseFloat(item.sum_in_cost)
      sum_out_cost += parseFloat(item.sum_out_cost)
      // sum_balance_cost += parseFloat(item.sum_balance_cost)
      sum_in_total += parseFloat(item.sum_in_total)
      sum_out_total += parseFloat(item.sum_out_total)
      // sum_balance_total += parseFloat(item.sum_balance_total)
    })

    return(
      <tr>
        <td colSpan={4} className='text-right'><div className='bd-sum br'><b>ยอดรวมสุทธิ</b></div></td>
        <td className='text-center'><div className='bd-sum br'><b>{this.getNumberFormat(sum_in_quantity)}</b></div></td>
        <td className='text-right'><div className='bd-sum br'><b>{this.getNumberFormat(sum_in_cost)}</b></div></td>
        <td className='text-right'><div className='bd-sum br'><b>{this.getNumberFormat(sum_in_total)}</b></div></td>
        <td className='text-center'><div className='bd-sum br'><b>{this.getNumberFormat(sum_out_quantity)}</b></div></td>
        <td className='text-right'><div className='bd-sum br'><b>{this.getNumberFormat(sum_out_cost)}</b></div></td>
        <td className='text-right'><div className='bd-sum br'><b>{this.getNumberFormat(sum_out_total)}</b></div></td>
        <td className='text-center'><div className='bd-sum br'><b>-</b></div></td>
        <td className='text-right'><div className='bd-sum br'><b>-</b></div></td>
        <td className='text-right'><div className='bd-sum br'><b>-</b></div></td>
      </tr>
    )
  }

  renderColTitle(item) {
    return(
      <td colSpan={13}>
        <div className='bg-title br'><b>{item}</b></div>
      </td>
    )
  }

  renderRowData(data,_index) {
    var sum_all_day_in_cost = 0
    var sum_all_day_in_quantity = 0
    var sum_all_day_in_total = 0

    var sum_all_day_out_cost = 0
    var sum_all_day_out_quantity = 0
    var sum_all_day_out_total = 0

    var sum_all_day_balance_cost = 0
    var sum_all_day_balance_quantity = 0
    var sum_all_day_balance_total = 0
    
    return(
        data.dataList.map((item, i) => {
          sum_all_day_in_cost = (sum_all_day_in_cost*1) + (item.sum_in_cost*1)
          sum_all_day_in_quantity = (sum_all_day_in_quantity*1) + (item.sum_in_quantity*1)
          sum_all_day_in_total = (sum_all_day_in_total*1) + (item.sum_in_total*1)

          sum_all_day_out_cost = (sum_all_day_out_cost*1) + (item.sum_out_cost*1)
          sum_all_day_out_quantity = (sum_all_day_out_quantity*1) + (item.sum_out_quantity*1)
          sum_all_day_out_total = (sum_all_day_out_total*1) + (item.sum_out_total*1)

          sum_all_day_balance_cost = (sum_all_day_balance_cost*1) + (item.sum_balance_cost*1)
          sum_all_day_balance_quantity = (sum_all_day_balance_quantity*1) + (item.sum_balance_quantity*1)
          sum_all_day_balance_total = (sum_all_day_balance_total*1) + (item.sum_balance_total*1)

          // var check_last = "none" 
          // if (i===this.state.data.length-1) {
          //   check_last = ""
          // }
          if (typeof item.description!=='undefined') {
            return(
              <tr key={i}>
                {this.renderColTitle(item.description)}
              </tr>  
            )  
          } 
          let _index = 0
          return(
            <tr key={i}>
              <td className='text-center'>
                {
                  item.meta.added_date.map((added_date, index) => {
                    if (added_date!==''&&index===0)
                      _index = 1
                    return(
                      <div key={index} className="bd-date br">
                        <div>{added_date!==''?(index+_index)*1:<br />}</div>
                      </div>
                    )
                  })  
                }
                <div className="bd-sum"><br /></div> 
              </td>
              <td className='text-center'>
                {
                  item.meta.added_date.map((added_date, index) => {
                    return(
                      <div key={index} className="bd-date br">
                        <div>{added_date===''?<br />:added_date}</div>
                      </div>
                    )
                  })  
                }
                <div className="bd-sum"><br /></div> 
              </td>
              <td className='text-center'>
                {
                  item.meta.id.map((id, index) => {
                    return(
                      <div key={index} className="bd-date br">
                        {id===''?<div><br /></div>
                        :
                        <div>
                          {id}
                        </div>}
                      </div>
                    )
                  })  
                }
                <div className="bd-sum"><br /></div> 
              </td>
              <td className='text-center'>
                {
                  item.meta.bill_type.map((bill_type, index) => {
                    return(
                      <div key={index} className="bd-date br">
                        <div>{bill_type}</div>
                      </div>
                    )
                  })  
                }
                <div className="bd-sum br text-right"><b>รวม</b></div>  
              </td>
              <td className="text-center">
                {
                  item.meta.in_quantity.map((in_quantity, index) => {
                    let bd_sum = ""
                    if (index===item.meta.in_quantity.length-1) {
                      bd_sum = "bd-sum"
                    }

                    return(
                      <div key={index} className={'bd-date br '+bd_sum}>
                        <div>{this.getNumberFormat(in_quantity)}</div>
                      </div>
                    )
                  })
                }
                <div className="bd-sum br">{this.getNumberFormat(item.sum_in_quantity)}</div>  
                {/* <div style={{display:check_last}} className={(i<data.length-1?'bd-sum br':'br')}><b>{this.getNumberFormat(sum_all_day_in_quantity)}</b></div>  */}
              </td>
              <td className="text-right">
                {
                  item.meta.in_cost.map((in_cost, index) => {
                    let bd_sum = ""
                    if (index===item.meta.in_cost.length-1) {
                      bd_sum = "bd-sum"
                    }

                    return(
                      <div key={index} className={'bd-date br '+bd_sum}>
                        <div>{this.getNumberFormat(in_cost)}</div>
                      </div>
                    )
                  })
                }
                <div className="bd-sum br">(เฉลี่ย) {this.getNumberFormat(item.sum_in_cost/item.sum_in_quantity)}</div>  
                {/* <div style={{display:check_last}} className={(i<data.length-1?'bd-sum br':'br')}><b>{this.getNumberFormat(sum_all_day_in_cost)}</b></div>  */}
              </td>
              <td className="text-right">
                {
                  item.meta.in_total.map((in_total, index) => {
                    let bd_sum = ""
                    if (index===item.meta.in_total.length-1) {
                      bd_sum = "bd-sum"
                    }

                    return(
                      <div key={index} className={'bd-date br '+bd_sum}>
                        <div>{this.getNumberFormat(in_total)}</div>
                      </div>
                    )
                  })
                }
                <div className="bd-sum br">{this.getNumberFormat(item.sum_in_total)}</div>  
                {/* <div style={{display:check_last}} className={(i<data.length-1?'bd-sum br':'br')}><b>{this.getNumberFormat(sum_all_day_in_total)}</b></div>  */}
              </td>
              <td className="text-center">
                {
                  item.meta.out_quantity.map((out_quantity, index) => {
                    let bd_sum = ""
                    if (index===item.meta.out_quantity.length-1) {
                      bd_sum = "bd-sum"
                    }

                    return(
                      <div key={index} className={'bd-date br '+bd_sum}>
                        <div>{this.getNumberFormat(out_quantity)}</div>
                      </div>
                    )
                  })
                }
                <div className="bd-sum br">{this.getNumberFormat(item.sum_out_quantity)}</div>
                {/* <div style={{display:check_last}} className={(i<data.length-1?'bd-sum br':'br')}><b>{this.getNumberFormat(sum_all_day_out_quantity)}</b></div>  */}
              </td>
              <td className="text-right">
                {
                  item.meta.out_cost.map((out_cost, index) => {
                    let bd_sum = ""
                    if (index===item.meta.out_cost.length-1) {
                      bd_sum = "bd-sum"
                    }

                    return(
                      <div key={index} className={'bd-date br '+bd_sum}>
                        <div>{this.getNumberFormat(out_cost)}</div>
                      </div>
                    )
                  })
                }
                <div className="bd-sum br">(เฉลี่ย) {this.getNumberFormat(item.sum_out_cost/item.sum_out_quantity)}</div>
                {/* <div style={{display:check_last}} className={(i<data.length-1?'bd-sum br':'br')}><b>{this.getNumberFormat(sum_all_day_out_cost)}</b></div>  */}
              </td>
              <td className="text-right">
                {
                  item.meta.out_total.map((out_total, index) => {
                    let bd_sum = ""
                    if (index===item.meta.out_total.length-1) {
                      bd_sum = "bd-sum"
                    }

                    return(
                      <div key={index} className={'bd-date br '+bd_sum}>
                        <div>{this.getNumberFormat(out_total)}</div>
                      </div>
                    )
                  })
                }
                <div className="bd-sum br">{this.getNumberFormat(item.sum_out_total)}</div>
                {/* <div style={{display:check_last}} className={(i<data.length-1?'bd-sum br':'br')}><b>{this.getNumberFormat(sum_all_day_out_total)}</b></div>  */}
              </td>
              <td className="text-center">
                {
                  item.meta.balance_quantity.map((balance_quantity, index) => {
                    let bd_sum = ""
                    if (index===item.meta.balance_quantity.length-1) {
                      bd_sum = "bd-sum"
                    }

                    return(
                      <div key={index} className={'bd-date br '+bd_sum}>
                        <div>{this.getNumberFormat(balance_quantity)}</div>
                      </div>
                    )
                  })
                }
                <div className="bd-sum br">{'-'}</div>
                {/* <div style={{display:check_last}} className={(i<data.length-1?'bd-sum br':'br')}><b>{'-'}</b></div> */}
              </td>
              <td className="text-right">
                {
                  item.meta.balance_cost.map((balance_cost, index) => {
                    let bd_sum = ""
                    if (index===item.meta.balance_cost.length-1) {
                      bd_sum = "bd-sum"
                    }

                    return(
                      <div key={index} className={'bd-date br '+bd_sum}>
                        <div>{this.getNumberFormat(balance_cost)}</div>
                      </div>
                    )
                  })
                }
                <div className="bd-sum br">{'-'}</div>
                {/* <div style={{display:check_last}} className={(i<data.length-1?'bd-sum br':'br')}><b>{'-'}</b></div> */}
              </td>
              <td className="text-right">
                {
                  item.meta.balance_total.map((balance_total, index) => {
                    let bd_sum = ""
                    if (index===item.meta.balance_total.length-1) {
                      bd_sum = "bd-sum"
                    }

                    return(
                      <div key={index} className={'bd-date br '+bd_sum}>
                        <div>{this.getNumberFormat(balance_total)}</div>
                      </div>
                    )
                  })
                }
                <div className="bd-sum br">{'-'}</div>
                {/* <div style={{display:check_last}} className={(i<data.length-1?'bd-sum br':'br')}><b>{'-'}</b></div> */}
              </td>
            </tr>
          )
        })      
    )
  }

  // renderRowData(data,_index) {
  //   return(
  //     data.dataList.map((item,i) => {
  //       return(
  //         <tr key={i}>
  //           <td className='text-left'>
  //             <div className="bd-date"><b>{item.description}</b></div>
  //             {
  //               item.meta.added_date.map((added_date, index) => {
  //                 return(
  //                   <div key={index} className="bd-date">
  //                     <div>{index+1}. {added_date}</div>
  //                   </div>
  //                 )
  //               })  
  //             }
  //           </td>
  //           <td className='text-center'>
  //             <div className="bd-date"><br/></div>
  //             {
  //               item.meta.id.map((id, index) => {
  //                 return(
  //                   <div key={index} className="bd-date">
  //                     <div>{id===''||id===undefined?'-':id}</div>
  //                   </div>
  //                 )
  //               })  
  //             }
  //           </td>
  //           <td className='text-center'>
  //             <div className="bd-date"><br/></div>
  //             {
  //               item.meta.bill_type.map((bill_type, index) => {
  //                 return(
  //                   <div key={index} className="bd-date">
  //                     <div>{bill_type===''||bill_type===undefined?'-':bill_type}</div>
  //                   </div>
  //                 )
  //               })  
  //             }
  //           </td>
  //           <td>
  //             <div className="bd-date"><br/></div>
  //             {
  //               item.meta.id.map((id, index) => {
  //                 let bd_sum = ''
  //                 if (index===item.meta.id.length-1&&item.sum_row)
  //                   bd_sum = 'bd-sum'

  //                 return(
  //                   <div key={index} className={'bd-date '+bd_sum}>
  //                     <div><br/></div>
  //                   </div>
  //                 )
  //               })
  //             }
  //             <div className={(i<data.dataList.length-1?'':'')} style={{display:item.sum_row?'':'none'}}><b>รวม/วัน</b></div>
  //           </td>

  //           <td className='text-center'>
  //             <div className="bd-date"><br/></div>
  //             {
  //               item.meta.in_quantity.map((in_quantity, index) => {
  //                 let bd_sum = ''
  //                 if (index===item.meta.in_quantity.length-1&&item.sum_row)
  //                   bd_sum = 'bd-sum'

  //                 return(
  //                   <div key={index} className={'bd-date '+bd_sum}>
  //                     <div className='text-center'>{this.getNumberFormat(in_quantity)}</div>
  //                   </div>
  //                 )
  //               })
  //             }
  //             <div className={(i<data.dataList.length-1?'':' text-center')} style={{display:item.sum_row?'':'none'}}>{this.getNumberFormat(item.sum_in_quantity)}</div>
  //           </td>
  //           <td className='text-center'>
  //             <div className="bd-date"><br/></div>
  //             {
  //               item.meta.in_cost.map((in_cost, index) => {
  //                 let bd_sum = ''
  //                 if (index===item.meta.in_cost.length-1&&item.sum_row)
  //                   bd_sum = 'bd-sum'

  //                 return(
  //                   <div key={index} className={'bd-date '+bd_sum}>
  //                     <div className='text-center'>{this.getNumberFormat(in_cost)}</div>
  //                   </div>
  //                 )
  //               })
  //             }
  //             <div className={(i<data.dataList.length-1?'':' text-center')} style={{display:item.sum_row?'':'none'}}>{this.getNumberFormat(item.sum_in_cost)}</div>
  //           </td>
  //           <td className='text-center'>
  //             <div className="bd-date"><br/></div>
  //             {
  //               item.meta.in_total.map((in_total, index) => {
  //                 let bd_sum = ''
  //                 if (index===item.meta.in_total.length-1&&item.sum_row)
  //                   bd_sum = 'bd-sum'

  //                 return(
  //                   <div key={index} className={'bd-date '+bd_sum}>
  //                     <div className='text-center'>{this.getNumberFormat(in_total)}</div>
  //                   </div>
  //                 )
  //               })
  //             }
  //             <div className={(i<data.dataList.length-1?'':' text-center')} style={{display:item.sum_row?'':'none'}}>{this.getNumberFormat(item.sum_in_total)}</div>
  //           </td>

  //           <td className='text-center'>
  //             <div className="bd-date"><br/></div>
  //             {
  //               item.meta.out_quantity.map((out_quantity, index) => {
  //                 let bd_sum = ''
  //                 if (index===item.meta.out_quantity.length-1&&item.sum_row)
  //                   bd_sum = 'bd-sum'

  //                 return(
  //                   <div key={index} className={'bd-date '+bd_sum}>
  //                     <div className='text-center'>{this.getNumberFormat(out_quantity)}</div>
  //                   </div>
  //                 )
  //               })
  //             }
  //             <div className={(i<data.dataList.length-1?'':' text-center')} style={{display:item.sum_row?'':'none'}}>{this.getNumberFormat(item.sum_out_quantity)}</div>
  //           </td>
  //           <td className='text-center'>
  //             <div className="bd-date"><br/></div>
  //             {
  //               item.meta.out_cost.map((out_cost, index) => {
  //                 let bd_sum = ''
  //                 if (index===item.meta.out_cost.length-1&&item.sum_row)
  //                   bd_sum = 'bd-sum'

  //                 return(
  //                   <div key={index} className={'bd-date '+bd_sum}>
  //                     <div className='text-center'>{this.getNumberFormat(out_cost)}</div>
  //                   </div>
  //                 )
  //               })
  //             }
  //             <div className={(i<data.dataList.length-1?'':' text-center')} style={{display:item.sum_row?'':'none'}}>{this.getNumberFormat(item.sum_out_cost)}</div>
  //           </td>
  //           <td className='text-center'>
  //             <div className="bd-date"><br/></div>
  //             {
  //               item.meta.out_total.map((out_total, index) => {
  //                 let bd_sum = ''
  //                 if (index===item.meta.out_total.length-1&&item.sum_row)
  //                   bd_sum = 'bd-sum'

  //                 return(
  //                   <div key={index} className={'bd-date '+bd_sum}>
  //                     <div className='text-center'>{this.getNumberFormat(out_total)}</div>
  //                   </div>
  //                 )
  //               })
  //             }
  //             <div className={(i<data.dataList.length-1?'':' text-center')} style={{display:item.sum_row?'':'none'}}>{this.getNumberFormat(item.sum_out_total)}</div>
  //           </td>

  //           <td className='text-center'>
  //             <div className="bd-date"><br/></div>
  //             {
  //               item.meta.balance_quantity.map((balance_quantity, index) => {
  //                 let bd_sum = ''
  //                 if (index===item.meta.balance_quantity.length-1&&item.sum_row)
  //                   bd_sum = 'bd-sum'

  //                 return(
  //                   <div key={index} className={'bd-date '+bd_sum}>
  //                     <div className='text-center'>{this.getNumberFormat(balance_quantity)}</div>
  //                   </div>
  //                 )
  //               })
  //             }
  //             <div className={(i<data.dataList.length-1?'':' text-center')} style={{display:item.sum_row?'':'none'}}>{this.getNumberFormat(item.sum_balance_quantity)}</div>
  //           </td>
  //           <td className='text-center'>
  //             <div className="bd-date"><br/></div>
  //             {
  //               item.meta.balance_cost.map((balance_cost, index) => {
  //                 let bd_sum = ''
  //                 if (index===item.meta.balance_cost.length-1&&item.sum_row)
  //                   bd_sum = 'bd-sum'

  //                 return(
  //                   <div key={index} className={'bd-date '+bd_sum}>
  //                     <div className='text-center'>{this.getNumberFormat(balance_cost)}</div>
  //                   </div>
  //                 )
  //               })
  //             }
  //             <div className={(i<data.dataList.length-1?'':' text-center')} style={{display:item.sum_row?'':'none'}}>{this.getNumberFormat(item.sum_balance_cost)}</div>
  //           </td>
  //           <td className='text-center'>
  //             <div className="bd-date"><br/></div>
  //             {
  //               item.meta.balance_total.map((balance_total, index) => {
  //                 let bd_sum = ''
  //                 if (index===item.meta.balance_total.length-1&&item.sum_row)
  //                   bd_sum = 'bd-sum'

  //                 return(
  //                   <div key={index} className={'bd-date '+bd_sum}>
  //                     <div className='text-center'>{this.getNumberFormat(balance_total)}</div>
  //                   </div>
  //                 )
  //               })
  //             }
  //             <div className={(i<data.dataList.length-1?'':' text-center')} style={{display:item.sum_row?'':'none'}}>{this.getNumberFormat(item.sum_balance_total)}</div>
  //           </td>
  //         </tr>
  //       )
  //     })
  //   )
  // }

  renderTable(data,index,length) {
    return(
        <table className='table table-print-report-stock-card-cost'>
          <thead>
            <tr>
              <th rowSpan={2} style={{width:"50px"}} className="text-center">ลำดับ</th>
              <th rowSpan={2} style={{width:"200px"}} className="text-center">วันที่</th>
              <th rowSpan={2} style={{width:"150px"}} className="text-center">เลขที่เอกสาร</th>
              <th rowSpan={2} style={{width:"150px"}} className="text-center">ประเภท</th>
              <th className="text-center" colSpan={3}>นำเข้า</th>
              <th className="text-center" colSpan={3}>ส่งออก</th>
              <th className="text-center" colSpan={3}>คงเหลือ</th>
            </tr>
            <tr>
              <th style={{width:'90px'}} className="text-center">จำนวน</th>
              <th style={{width:'90px'}} className="text-center">ต้นทุน</th>
              <th style={{width:'90px'}} className="text-center">รวม</th>
              <th style={{width:'90px'}} className="text-center">จำนวน</th>
              <th style={{width:'90px'}} className="text-center">ต้นทุน</th>
              <th style={{width:'90px'}} className="text-center">รวม</th>
              <th style={{width:'90px'}} className="text-center">จำนวน</th>
              <th style={{width:'90px'}} className="text-center">ต้นทุน​ (เฉลี่ย)</th>
              <th style={{width:'90px'}} className="text-center">รวม</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData(data,index)}  
            {/* {index===length?this.renderRowSummary():''} */}
          </tbody>
        </table>
    )
  }

  getDate() {
    let {day,year,month,isRange,startDate,endDate} = this.props
    if (isRange==='true') {
      return 'ประจำวันที่ '+startDate+' - '+endDate
    } else {
      let text = 'ประจำวันที่ '
      text += day+' '+momentHelper.getMonthText(month)+' '+year
      if (year==='0'||year==='00') {
        text = 'ทั้งหมด'
      } else if (month==='0'||month==='00') {
        text = 'ประจำปี '+year
      } else if (day==='0'||day==='00') {
        text = 'ประจำเดือน '+momentHelper.getMonthText(month)+' '+year
      }
      return text
    }  
  }

  renderComponentPage(data,index,length) {
    return(
            <div className={'font-print'}>
              <header className="align-center">
                <h2 className={this.state.title_destop}>{'ตารางรายงานความเคลื่อนไหวต้นทุนสต็อก (Stock Card Cost)'}</h2>
                <div className='text-center'>
                  {this.getDate()}
                </div>  
              </header>
              <div className=''>
                {this.renderTable(data,index,length)}
              </div>  
            </div>
    )
  }

  renderNoData() {
    return(
      <div className='font-print'>
        <header className="text-center">
          <h2>{this.state.report_title}</h2>
        </header>
      </div>
    )
  }

  render(){
    let {data} = this.state
    if (data.data.length===0) {
      return(
        <div>
          <PrintPreview
            size={'landscape'}
            leftBarTitle={this.props.title}
          >
            {this.renderNoData()}
          </PrintPreview>
        </div>
      )
    } else {
      return(
        <div>
          <PrintPreview
            size={'landscape'}
            leftBarTitle={this.props.title}
          >
            {
              data.dataFormat.map((item,index) => {
                return(
                  this.renderComponentPage(item,index,data.dataFormat.length-1)
                )
              })
            }
          </PrintPreview>
        </div>
      )
    }
  }
}

PrintReportStockCardCost.defaultProps = {
  title:'รายงานความเคลื่อนไหวต้นทุนสต็อก (Stock Card Cost)'
}

export default PrintReportStockCardCost;





// WEBPACK FOOTER //
// ./src/view/print/stock/PrintReportStockCardCost.js